interface PermissionInterface {
  [key: string]: string;
}

export enum Permission {
  CanViewPartnerProfile = 'CanViewPartnerProfile',
  CanCreatePartnerProfile = 'CanCreatePartnerProfile',
  CanEditPartnerProfile = 'CanEditPartnerProfile',
  CanDeletePartnerProfile = 'CanDeletePartnerProfile',
  CanCreateWfpProfile = 'CanCreateWfpProfile',
  CanEditWfpProfile = 'CanEditWfpProfile',
  CanViewAdHocDistributions = 'CanViewAdHocDistributions',
  CanViewStocks = 'CanViewStocks',
  CanViewMonthlyReports = 'CanViewMonthlyReports',
  CanViewMonthlyReportsGlobal = 'CanViewMonthlyReportsGlobal',
  CanCreateAdHocs = 'CanCreateAdHocs',
  CanViewPartnershipOpportunity = 'CanViewPartnershipOpportunity',
  CanSubmitOpportunity = 'CanSubmitOpportunity',
  CanCreatePartnershipOpportunity = 'CanCreatePartnershipOpportunity',
  CanAccessPartnerships = 'CanAccessPartnerships',
  CanAccessInvoicing = 'CanAccessInvoicing',
  CanCreatePartnershipsUser = 'CanCreatePartnershipsUser',
  CanAccessPartnershipsUsers = 'CanAccessPartnershipsUsers',
  CanCreateNfrSigning = 'CanCreateNfrSigning',
  CanEditNfrSigning = 'CanEditNfrSigning',
  CanViewNfrSigning = 'CanViewNfrSigning',
  CanAccessSpotcheck = 'CanAccessSpotcheck',
  CanViewSpotcheck = 'CanViewSpotcheck',
  CanCreateSpotcheck = 'CanCreateSpotcheck',
  CanEditSpotcheck = 'CanEditSpotcheck',
  CanAccessReportsDataExport = 'CanAccessReportsDataExport',
  CanViewPartnershipOpportunityAttachment = 'CanViewPartnershipOpportunityAttachment',
  CanExportUserData = 'CanExportUserData',
  CanEditPartnerUserCountryAndPartner = 'CanEditPartnerUserCountryAndPartner',
  CanViewReportQuality = 'CanViewReportQuality'
}

export const PERMISSIONS: PermissionInterface = {
  CanExportUserData: 'profiles.can_export_user_data',
  CanViewPartnerProfile: 'profiles.view_partnerprofile',
  CanCreatePartnerProfile: 'profiles.add_partnerprofile',
  CanEditPartnerProfile: 'profiles.change_partnerprofile',
  CanDeletePartnerProfile: 'profiles.delete_partnerprofile',
  CanCreateWfpProfile: 'profiles.add_wfpprofile',
  CanEditWfpProfile: 'profiles.change_wfpprofile',
  CanViewAdHocDistributions: 'reports.view_adhocdistributionreportsubmission',
  CanViewStocks: 'stocks.can_view_stocks',
  CanViewMonthlyReports: 'reports.view_distributionreport',
  CanViewMonthlyReportsGlobal: 'reports.view_distributionreport#global',
  CanCreateAdHocs: 'reports.add_adhocdistributionreportsubmission',
  CanViewPartnershipOpportunity: 'opportunities.can_view_fla_opportunity',
  CanSubmitOpportunity: 'opportunities.can_submit_fla_opportunity',
  CanCreatePartnershipOpportunity: 'opportunities.can_add_fla_opportunity',
  CanAccessPartnerships: 'accounts.can_access_fla_module',
  CanAccessInvoicing: 'accounts.can_access_invoicing_module',
  CanCreatePartnershipsUser: 'accounts.can_create_user',
  CanAccessPartnershipsUsers: 'accounts.can_access_fla_user_module',
  CanCreateNfrSigning: 'opportunities.can_create_digitalccpsigning',
  CanEditNfrSigning: 'opportunities.can_change_digitalccpsigning',
  CanViewNfrSigning: 'opportunities.can_view_digitalccpsigning',
  CanAccessSpotcheck: 'accounts.can_access_spot_check_module',
  CanViewSpotcheck: 'spotchecks.can_view_spot_checks',
  CanCreateSpotcheck: 'spotchecks.can_create_spot_checks',
  CanEditSpotcheck: 'spotchecks.can_edit_spot_checks',
  CanAccessReportsDataExport: 'reports.can_view_partner_data_exports',
  CanViewPartnershipOpportunityAttachment:
    'opportunities.can_view_opportunityattachment',
  CanEditPartnerUserCountryAndPartner:
    'profiles.can_edit_user_country_and_partner',
  CanViewReportQuality: 'profiles.can_view_report_quality'
};
